import { render, staticRenderFns } from "./selectCommunityFloor.vue?vue&type=template&id=afe00b5a&scoped=true"
import script from "./selectCommunityFloor.vue?vue&type=script&lang=js"
export * from "./selectCommunityFloor.vue?vue&type=script&lang=js"
import style0 from "./selectCommunityFloor.vue?vue&type=style&index=0&id=afe00b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe00b5a",
  null
  
)

export default component.exports